import { useDispatch } from "react-redux";

import { Tooltip } from "@similarweb/ui-components";

import { showErrorToast } from "app/actions/toast_actions";
import { translate } from "app/filters/i18nFilter";
import { useCopiedNotification } from "app/pages/sales-intelligence/hooks/useCopiedNotification";
import { StyledIconButton } from "app/pages/sales-intelligence/modules/ai-agent/components/ChatMessage/styles";

type CopyButtonProps = {
    markdownRef: React.RefObject<HTMLDivElement | null>;
    onCopy?: () => void;
};

export const CopyButton = ({ markdownRef, onCopy }: CopyButtonProps) => {
    const dispatch = useDispatch();
    const { isCopied, onCopy: onCopyNotification } = useCopiedNotification();

    const handleCopyFormatted = async () => {
        const html = markdownRef.current?.innerHTML || "";
        const text = markdownRef.current?.innerText || "";

        onCopy?.();

        try {
            await navigator.clipboard.write([
                new ClipboardItem({
                    "text/html": new Blob([html], { type: "text/html" }),
                    "text/plain": new Blob([text], { type: "text/plain" }),
                }),
            ]);

            onCopyNotification();
        } catch {
            dispatch(showErrorToast(translate("copy_to_clipboard_button.toast.failure")));
        }
    };

    return (
        <Tooltip content={translate(isCopied ? "si.common.copied" : "si.common.copy")}>
            <StyledIconButton
                onClick={() => void handleCopyFormatted()}
                iconName={isCopied ? "checked" : "copy"}
                iconSize="xs"
                type="flat"
                dataAutomation="copy-button"
            />
        </Tooltip>
    );
};
